<template>
  <modal>
    <div class="header">
      <h1 style="text-align: center">{{title}}</h1>
      <i class="material-icons clickable close" @click="$emit('close')" >close</i>
      <i class="material-icons clickable back" @click="edit=true" v-if="!edit">arrow_back</i>
    </div>
    <form class="form-body" v-if="edit">
      <div class="input">
        <label>Habit Name</label>
        <input type="text" v-model="habit.name" />
      </div>
      <div class="input small-top">
        <label>
          Describe your new habit. What exactly are you going to do?
        </label>
        <input type="text" v-model="habit.description" />
      </div>
      <div class="input small-top">
        <label>
          Why is this important to you?
        </label>
        <input type="text" v-model="habit.why" />
      </div>

      <div class="input small-top">
        <label>
          Picture yourself doing the habit.  Where exactly will you be doing it? (e.g., at your desk, in the gym, in your team meeting, etc.  Research shows we are more likely to do something if we plan when and WHERE we will do the activity.)
        </label>
        <textarea v-model="habit.visualization" />
      </div>
    </form>
    <button class="footer" v-if="edit" @click="edit=false">
      <h1>Next</h1>
    </button>
    <form class="form-body" v-else>
      <div class="input">
        <label>Choose the color of your habit</label>
        <swatches :value="habit.color" @input="c => habit.color = c.hex" class="full-width small-top" />
      </div>

      <div class="input small-top">
        <label>What days of the week will you be doing your new habit?</label>
        <week-btns class="small-top" :color="habit.color" :week="habit.days_of_week" />
      </div>

      <div class="input small-top gutter">
        <label>What time of the day?</label>
        <timepicker v-model="habit.time" />
      </div>
      <!-- <div class="error-msg">Hello</div> -->
    </form>
    <button class="footer" v-if="!edit" @click="save">
      <h1>Save</h1>
    </button>
  </modal>
</template>

<script>
import modal from "@/components/modal";
import weekBtns from "@/components/weekBtns";
import { Swatches } from "vue-color";
import timepicker from "@/components/timepicker";

export default {
  components: { modal, Swatches, weekBtns, timepicker },
  props: {habit: Object, title: {default: "New Habit" } },
  data() {
    return {
      edit: true
    };
  },
  methods: {
    save() {
      this.$emit("save");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../styles/colors";
@import "../../../styles/fonts";

.top-bottom {
  padding: .3em 0px;
}

.header {
  background-color: @primaryColor;
  font-family: @header;
  color: white;
  margin: 0px auto;
  width: 100%;
  position: relative;

  .top-bottom;
}

.footer {
  .header;
}

.form-body {
  background-color: darkgray;
  color: white;
  padding: 1em;
}

.close {
  position: absolute;
  right: 1em;
  top: 10px;
}

.back {
  position: absolute;
  left: 1em;
  top: 10px;
}


</style>
